import { useSelector } from "react-redux";
import { selectCurrent } from "../../../../../../../redux/settings/selectors";
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../../hooks/hooks";
import Table from "../../../../../../../common/components/table";
import { quotes } from "../../../../../../../redux/quotes/action";
import { selectQuotesListItems } from "../../../../../../../redux/quotes/selector";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../../components/PageLoader";
import storePersist from "../../../../../../../redux/storePersist";
import _ from 'lodash';
import useWindowDimensions from "../../../../../../../hooks/useWindowsDimensions";
import MobileViewTable from "../../../../../../../common/components/mobile-view-table.component";

const CustomerQuotes = () => {
  const dispatch = useAppDispatch()
  const { height, width } = useWindowDimensions();
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const itemsData = useSelector(selectQuotesListItems)
  const roleData = _.find(storePersist.get('userProfile')?.current?.items[0]?.Message?.Roles, ['Name', 'Logistics_Customer']);
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Message.category_name', headerName: 'Category Name', sortable: true, filter: true },
      { field: 'Message.quote.price.value', headerName: 'Quote price', isCurrencyValueFormat: true },
      { field: 'Message.CreatedOnUtc', headerName: 'CreatedOn', isDateValueFormat: true },
      { field: 'Message.ModifiedOnUtc', headerName: 'ModifiedOn', isDateValueFormat: true },
    ]);
  }

  const fetchQuotes = () => {
    dispatch(quotes.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/logistics-quotes/list`, entity: 'quotes', jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Filters": [
          {
            "FieldName": "CustomerId",
            "FilterOperatorId": 1,
            "FieldValue": roleData?.Id,
            "FieldType": "number"
          }]
      }
    }))
  }
  useEffect(() => {
    createColumnDefs()
    fetchQuotes()
  }, [pageData, pageSize])

  const handleEdit = (data: any) => {
    navigate(`${data?.Message?.Id}`)
  }
  return (
    <>
      {itemsData?.isLoading ? <PageLoader />
        :
        <>

          <Table columnData={columnDefs} rowData={itemsData?.result?.items} onEdit={handleEdit}
            setPageSize={setPageSize} setPageData={setPageData} paginationData={itemsData?.result?.pagination} headingName="Quotes" />

        </>
      }
    </>

  );
};

export default CustomerQuotes;


